export default __webpack_public_path__ + "static/media/21.38aec6df.png";